import React from 'react'
import styles from './PlayerListBar.module.css'
import Player from './Player'
import { Player as PlayerModel } from '../../models'

export interface PlayerListBarProps {
    players: PlayerModel[]
}

export default function PlayerListBar(props: PlayerListBarProps) {
    
    const players = props.players.map((player, i) => (
        <Player key={i} {...player} />
    ))

    return (
        <div className={styles.playerListBar}>
            {players}
        </div>
    )
}